import * as React from "react";
import { IInfoResponse } from "./info";

export const UserContext =
  // eslint-disable-next-line unicorn/no-null
  React.createContext<IInfoResponse | null>(null);

export function useUser() {
  const value = React.useContext(UserContext);

  if (value === null) {
    throw new Error("`Missing UserContext` in tree.");
  }

  return value;
}
